import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/sagas/pricingOptionsMapping/pricingOptionsMapping";
import PricingOptionCategoryList from "./smartComponents/pricingOptionCategoryList";

export class PricingOptionsMappingModule extends React.Component {
  componentDidMount() {
    this.props.fetchCurrentUser(this.props.queryParams);
  }

  render() {
    return (
      <div>
        <div className="chart-data-table">
          <div className="widget-wrapper active">
            <div className="widget">
              <div className="raw-data-table">
                {this.props.isLoading ? (
                  <LoadingAnimation text="Getting fresh data, this may take a moment..." customStyle="dark" />
                ) : (
                  <div>
                    <div className="md-handson-table">
                      <PricingOptionCategoryList />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    isLoading: state.pricingOptionsMapping.isLoading,
    pricingOptions: state.pricingOptionsMapping.pricingOptions
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser
  }
)(PricingOptionsMappingModule);

PricingOptionsMappingModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  queryParams: PropTypes.object
};
